import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en.json";
import hi from "./hi.json";
import te from "./te.json";
import kn from "./kn.json";

export const LANGUAGE_STORAGE_KEY = "wp_language";

function getInitialLanguage() {
  const savedLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY);
  return ["en", "hi", "te", "kn"].includes(savedLanguage) ? savedLanguage : "en";
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    hi: { translation: hi },
    te: { translation: te },
    kn: { translation: kn },
  },
  lng: getInitialLanguage(),
  fallbackLng: "en",
  supportedLngs: ["en", "hi", "te", "kn"],
  interpolation: { escapeValue: false },
});

export default i18n;
